module.exports = __webpack_public_path__ + "static/media/SF UI Display Semibold.57c32634.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SF-UI-Display/SF UI Display Semibold.woff
// module id = 215
// module chunks = 0